export const vehiclesWithDistinctLicence = (selectedVehicles) => {
  const deduplicated = {};
  selectedVehicles.forEach((sv) => {
    const licencePlateNumber = sv.vehicle ? sv.vehicle.licencePlateNumber : sv.licencePlateNumber;
    deduplicated[licencePlateNumber] = sv.vehicle ? { ...sv.vehicle, vehicleId: sv.vehicleId } : sv;
  });
  return Object.values(deduplicated);
};
